<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<!-- 조회부분 시작 -->
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<pc-rs-num-search ref="search" :scrId="scrId" />
				</sf-card>
			</div>
			<!-- 조회부분 끝 -->

			<!-- 그래프 부분 시작 -->
			<div class="sf-col sf-col-11">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-rs-num-graph ref="graph" @Refresh="Refresh" :scrId="scrId"></pc-rs-num-graph>
				</sf-card>
			</div>
			<!-- 그래프 부분 끝 -->
			<!-- 그리드 부분 시작 -->
			<div class="sf-col sf-col-9">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<pc-rs-num-table ref="table" @Refresh="Refresh" :scrId="scrId"></pc-rs-num-table>
				</sf-card>
			</div>
			<!-- 그리드 부분 시작 -->
		</div>
	</div>
</template>

<script>
import PcRsNumSearch from './Search/PcRsNumSearch.vue';
import PcRsNumTable from './Table/PcRsNumTable.vue';
import PcRsNumGraph from './Table/PcRsNumGraph.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {
		console.clear();
	},
	components: { PcRsNumSearch, PcRsNumTable, PcRsNumGraph },
	methods: {
		Refresh(currentPage = 1, pageUnit = 30) {
			this.$refs.search.searchList(currentPage, pageUnit);
		}
	}
};
</script>

<style></style>
